import { FeatureFlags } from "shared/models/FeatureFlags";
import { FeatureFlagsDto } from "./api/FeatureFlagsDto";

export class FeatureFlagsFromResponse {
    constructor(private featureFlagsFromResponse: FeatureFlagsDto | undefined) {}

    flags(): FeatureFlags {
        return {
            grants: this.featureFlagsFromResponse?.GRANTS ?? false,
            v360Sales: this.featureFlagsFromResponse?.V360_SALES ?? false,
            v360Notes: this.featureFlagsFromResponse?.V360_NOTES ?? false,
        };
    }
}
